import { render, staticRenderFns } from "./exchangeFail.vue?vue&type=template&id=3f64be84&scoped=true&"
import script from "./exchangeFail.vue?vue&type=script&lang=js&"
export * from "./exchangeFail.vue?vue&type=script&lang=js&"
import style0 from "./exchangeFail.vue?vue&type=style&index=0&id=3f64be84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64be84",
  null
  
)

export default component.exports